Wee.fn.make('detailLayout', {
	init: function() {
		var priv = this.$private;

		priv.initVars();

		Wee.screen.map([
			{
				min: 3,
				callback: function() {
					priv.desktopLayout();
				}
			}, {
				max: 2,
				callback: function() {
					priv.mobileLayout();
				}
			}
		]);
	}
}, {
	initVars: function() {
		this.$listing = $('ref:listing'),
		this.$leftColumn = $('ref:listing__left'),
		this.$rightColumn = $('ref:listing__right'),
		this.$productInfo = $('ref:productInfo'),
		this.$product = $('ref:product'),
		this.$options = $('ref:options'),
		this.$details = $('ref:details'),
		this.$moveLeft = [
			this.$product,
			this.$details
		],
		this.$moveRight = [
			this.$productInfo,
			this.$options
		],
		this.$resetAll = [
			this.$productInfo,
			this.$product,
			this.$options,
			this.$details
		];
	},

	/**
	 * Desktop layout
	 */
	desktopLayout: function() {
		var scope = this;

		scope.$moveLeft.forEach(function(el) {
			scope.$leftColumn.append(el);
		});

		scope.$moveRight.forEach(function(el) {
			scope.$rightColumn.append(el);
		});
	},

	/**
	 * Mobile layout
	 */
	mobileLayout: function() {
		var scope = this;

		scope.$resetAll.forEach(function(el) {
			scope.$listing.append(el);
		});
	}
});